import { render, staticRenderFns } from "./Downline.vue?vue&type=template&id=2574c841&scoped=true&"
import script from "./Downline.vue?vue&type=script&lang=ts&"
export * from "./Downline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2574c841",
  null
  
)

export default component.exports